for (const container of document.querySelectorAll<HTMLElement>(
  ".product-index"
)) {
  /* Add a slight delay on form submition */
  /* incase a user rapid selects filters */
  const filterForm = container.querySelector<HTMLFormElement>(
    ".product-index__form"
  );
  const filters = container.querySelectorAll<HTMLElement>(
    ".product-index__form input"
  );
  let filterTimer: ReturnType<typeof setTimeout> | null = null;

  if (filterForm && filters) {
    for (const filter of filters) {
      filter.addEventListener("click", function (event: Event): void {
        if (filterTimer) {
          clearTimeout(filterTimer);
          filterTimer = null;
        }
        filterTimer = setTimeout(function () {
          filterForm.submit();
        }, 500);
      });
    }
  }

  /* On desktop, display accordion open by default */
  const details = container.querySelector<HTMLElement>(
    ".product-index__sidebar details"
  );
  if (innerWidth >= 1024) {
    details?.setAttribute("open", "");
  }
}
